var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7009 1.01576C16.8525 0.559173 17.4984 0.559179 17.65 1.01576L20.8328 10.6014L21.3074 10.4438L20.8328 10.6014C21.0365 11.2147 21.6101 11.6287 22.2564 11.6287H32.5094C32.9964 11.6287 33.196 12.254 32.7991 12.5362L24.5419 18.4067C24.0047 18.7886 23.7797 19.4764 23.9874 20.1019L27.1502 29.627C27.3025 30.0858 26.7799 30.4722 26.386 30.1921L18.0446 24.2618C17.5242 23.8918 16.8267 23.8918 16.3063 24.2618L7.96494 30.1921C7.57098 30.4722 7.04837 30.0858 7.2007 29.627L10.3635 20.1019C10.5712 19.4764 10.3462 18.7886 9.80904 18.4067L1.55177 12.5362C1.15487 12.254 1.35451 11.6287 1.84149 11.6287H12.0945C12.7408 11.6287 13.3144 11.2147 13.5181 10.6014L16.7009 1.01576Z",
    fill: "white",
    stroke: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/starOutlined.2a3ff084571ac1d9ae4869b4c95f94e5.svg";
export { ForwardRef as ReactComponent };